<script type="text/javascript">
    import { http } from '../../http';
    import moment from 'moment';
    import axios from 'axios';
    import debounce from 'lodash/debounce';

    export default {
        data() {
            return {
                existingEntries: [],
                blockingResources: [],
                bookingRequestSource: false,
                loadingExistingBlockingResources: false,
            }
        },

        methods: {
            getExistingEntries: debounce(function () {
                this.existingEntries = [];

                let start = this.getSelectedStartDateTime();
                let end = this.getSelectedEndDateTime();

                if (!start || start.isValid() == false || !end || end.isValid() == false) {
                    return;
                }

                // Cancel the previous request if it's still running...
                if(this.bookingRequestSource){
                    this.bookingRequestSource.cancel('Operation canceled by the user.');
                }
                // Create a new cancel token for the new request...
                const CancelToken = axios.CancelToken;
                this.bookingRequestSource = CancelToken.source();

                http.get(`/app/calendar/${this.getSelectedCalendarId()}/bookings`, {
                    cancelToken: this.bookingRequestSource.token,
                    params: {
                        start: start.format('YYYY-MM-DD HH:mm'),
                        end: end.format('YYYY-MM-DD HH:mm'),
                        includeBlockedBookings : 1,
                    }
                }).then(({data}) => {
                    this.existingEntries = data.filter(entry => {
                            if (entry.type === 'booking') {
                                return entry.id !== this.getEditableBookingId();
                            } else if (entry.type === 'event') {
                                return entry.id !== this.getEditableEventId();
                            } else if (entry.type === 'team_meeting') {
                                return entry.id !== this.getEditableTeamMeetingId();
                            } else if (entry.type === 'contact_booking') {
                                return entry.id !== this.getEditableBookingId();
                            } else if (entry.type === 'calendar_block') {
                                return true;
                            }
                        })
                        .map(entry => {
                            entry.start = moment(entry.start).format('HH:mm');
                            entry.end = moment(entry.end).format('HH:mm');
                            return entry;
                        });
                }).catch(error => {
                });
            }, 50),

            getExistingResourcesInUseOnSelectedDay(is_edit_state) {

                if(this.loadingExistingBlockingResources === true) {
                    return;
                }

                this.loadingExistingBlockingResources = true;

                let start = this.getSelectedStartDateTime();
                let end = this.getSelectedEndDateTime();
                let products = this.booking.booking_products.map((product) => product.product_id);

                this.blockingResources = [];

                http.get(`/app/calendar/bookings/resources`, {
                    params: {
                        start: start.format('YYYY-MM-DD HH:mm:ss'),
                        end: end.format('YYYY-MM-DD HH:mm:ss'),
                        products: products
                    }
                }).then(({data}) => {

                    let blockingResources = [];

                    data.forEach(function(resource) {

                        if(is_edit_state){
                            if(resource.count > resource.maxCount) {
                                // Add the resource as a blocking one, so we can warn users about this...
                                blockingResources.push(resource);
                            }
                        }else{
                            // Apply an extra +1 to it, simulating a booking, if we are creating a new booking...
                            resource.count++;
                            // If the resource count breaches the max limit, it means we cannot book again...
                            if(resource.count >= resource.maxCount) {
                                // Add the resource as a blocking one, so we can warn users about this...
                                blockingResources.push(resource);
                            }
                        }

                    });

                    this.blockingResources = blockingResources;

                    this.loadingExistingBlockingResources = false;

                }).catch(error => {
                    this.loadingExistingBlockingResources = false;
                });
            },

            getSelectedCalendarId() {
                return this.booking.calendarid;
            },

            getSelectedStartDateTime() {
                return moment(`${this.booking.date} ${this.booking.start_time}`, 'DD-MM-YYYY HH:mm');
            },

            getSelectedEndDateTime() {
                return moment(`${this.booking.endDate} ${this.booking.end_time}`, 'DD-MM-YYYY HH:mm');
            },

            getEditableBookingId() {
                return this.booking ? this.booking.id : null;
            },

            getEditableEventId() {
                return this.event ? this.event.id : null;
            },

            getEditableTeamMeetingId() {
                return this.meeting ? this.meeting.id : null;
            }
        }
    }

</script>
